<template>
    <div class="text-center">
        <router-link :to="{ name: 'home' }" tag="a">
            <img :src="logo" class="logo-auth" alt="aNewItem Logo">
        </router-link>
    </div>
</template>

<script>
export default {
    name: "AuthHeader",
    data() {
        return {
            logo: require('../../../assets/anewitem.png'),
        }
    },
}
</script>